/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Immediateassistance1Inputs */

const en_questionnaire_immediateassistance1 = /** @type {(inputs: Questionnaire_Immediateassistance1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you need immediate assistance, please go to the reception.`)
};

const fr_questionnaire_immediateassistance1 = /** @type {(inputs: Questionnaire_Immediateassistance1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous avez besoin d'assistance immédiate, veuillez vous présenter à la réception.`)
};

/**
* | output |
* | --- |
* | "If you need immediate assistance, please go to the reception." |
*
* @param {Questionnaire_Immediateassistance1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_immediateassistance1 = /** @type {((inputs?: Questionnaire_Immediateassistance1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Immediateassistance1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_immediateassistance1(inputs)
	return fr_questionnaire_immediateassistance1(inputs)
});
export { questionnaire_immediateassistance1 as "questionnaire_immediateAssistance" }